<template>
    <div id="workstation-form-page">
        <workstation-form :form-type="'edit'"></workstation-form>
    </div>
</template>
<script>
import WorkstationForm from '../components/workstations/WorkstationForm';
export default {
    components: {
        'workstation-form': WorkstationForm,
    },
};
</script>
